module.exports = __webpack_public_path__ + "static/do-27bf1af1370cea7607b7369acb0fa7eb.png";